import DatasetTableList from "datasets/pages/tables/components/DatasetTableList";

export const DatasetTables = () => <DatasetTableList />;
